// @ts-nocheck
import { Column } from 'react-table'
import { CouponCustomHeader } from './CouponCustomHeader'
import { CouponUsage } from '../../core/_models'

const usersColumns: ReadonlyArray<Column<CouponUsage>> = [
  {
    Header: (props) => (
      <CouponCustomHeader tableProps={props} title='S.No' className='min-w-70px' />
    ),
    id: 'serialNo',
    Cell: ({ ...props }) => (
      <span>{props.row.index + 1}</span>
    ),
  },
  {
    Header: (props) => (
      <CouponCustomHeader tableProps={props} title='Coupon Code' className='min-w-125px' />
    ),
    id: 'coupon_code',
    Cell: ({ ...props }) => {
      const code = props.data[props.row.index].coupon?.code
      return <span>{code || '-'}</span>
    },
  },
  {
    Header: (props) => (
      <CouponCustomHeader tableProps={props} title='User Name' className='min-w-125px' />
    ),
    id: 'user_name',
    Cell: ({ ...props }) => {
      const name = props.data[props.row.index].user?.name
      return <span>{name || '-'}</span>
    },
  },
  {
    Header: (props) => (
      <CouponCustomHeader tableProps={props} title='User Email' className='min-w-150px' />
    ),
    id: 'user_email',
    Cell: ({ ...props }) => {
      const email = props.data[props.row.index].user?.email
      return <span>{email || '-'}</span>
    },
  },
  {
    Header: (props) => (
      <CouponCustomHeader tableProps={props} title='User Mobile' className='min-w-125px' />
    ),
    id: 'user_mobile',
    Cell: ({ ...props }) => {
      const mobile = props.data[props.row.index].user?.mobile
      return <span>{mobile || '-'}</span>
    },
  },
  {
    Header: (props) => (
      <CouponCustomHeader tableProps={props} title='Order ID' className='min-w-125px' />
    ),
    accessor: 'order_id',
    Cell: ({ ...props }) => {
      const order_id = props.data[props.row.index].order_id
      return <span>{order_id || '-'}</span>
    }
  },
  {
    Header: (props) => (
      <CouponCustomHeader tableProps={props} title='Applied Date' className='min-w-125px' />
    ),
    id: 'created_date',
    Cell: ({ ...props }) => (
      <span>
        {props.data[props.row.index].created_date
          ? new Date(props.data[props.row.index].created_date).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })
          : '-'}
      </span>
    ),
  },
]

export { usersColumns }
